import {ClassStep, ClassStepTransition} from "./ClassStep";
import {AbstractPlayableContent} from "../../../../playable/models/AbstractPlayableContent";
import {
  defaultVolumes,
  SoundParameters,
  SoundParametersActiveConfiguration
} from "../../../../player/models/parameters/SoundParameters";
import {VisualParameters} from "../../../../player/models/parameters/VisualParameters";
import {LoopParameters} from "../../../../player/models/parameters/LoopParameters";
import {loopTypeFromPlayableType} from "../../../../global/types/GlobalTypes";
import {ListPlayableContent} from "../../../../playable/models/ListPlayableContent";
import { i18n } from "../../../../../boot/i18n";

export const defaultDemoTransition: ClassStepTransition = {
  before: {
    title: i18n.t('demo.title') as string,
    description: i18n.t('demo.description') as string,
  },
  after: null
}
export const defaultResumeDemoTransition: ClassStepTransition = {
  before: {
    title: i18n.t('resumeDemo.title') as string,
    description: i18n.t('resumeDemo.description') as string,
  },
  after: null
}

export function getDefaultDemoConsolidationTransition(playableContent: ListPlayableContent): ClassStepTransition {
  const partListText = playableContent.playableTimeline.map((content) => content.name).join(', ');
  return {
    before: {
      title: i18n.t('consolidation.title') as string,
      description: i18n.t('consolidation.description', { partListText }) as string,
    },
    after: null
  }
}

export function createDemoStep(playableContent: AbstractPlayableContent, withLyrics: boolean, isStarted: boolean = false): ClassStep {
  const soundActiveConfiguration: SoundParametersActiveConfiguration = {
    MAIN: true,
    LEFT: true,
    RIGHT: true,
    MELODY: withLyrics,
    METRONOME: false,
  }
  return {
    id: -1,
    name: i18n.t('demo.name') as string,
    shortName: i18n.t('demo.shortName') as string,
    transitions: (playableContent instanceof ListPlayableContent)
      ? getDefaultDemoConsolidationTransition(playableContent)
      : (isStarted) ? defaultResumeDemoTransition : defaultDemoTransition,
    isOptional: true,
    requireValidation: false,
    playerConfig: {
      playerMode: 'preview',
      playerView: 'piano',
      startTempo: 'NORMAL',
      visualParameters: VisualParameters.fromHandConfiguration("BOTH_HAND", withLyrics),
      loopParameters: new LoopParameters(
        loopTypeFromPlayableType(playableContent.playableType),
        playableContent
      ),
      soundParameters: new SoundParameters(soundActiveConfiguration, defaultVolumes),
    }
  }
}
